import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
import { PickersDay } from "@mui/x-date-pickers";
import Responsive from "react-responsive";
import styled from "styled-components";
import { useSkipDaysQuery } from "../../SWR/SkipDays/useSkipDaysQuery";
import { AccountPageWrapper } from "../../Shared/components/PageWrapper/AccountPageWrapper";
import Loading from "../../Shared/components/loading";
import { AccountPageTitle } from "../utils/Page";
import { Legend } from "./Legend";
import { MySkippedDays } from "./MySkippedDays";
import SkipDayCalendar from "./SkipDayCalendar";
import { shouldDisableDate } from "../../SWR/SkipDays/skipDaysQuery-utils";
const mySkippedDaysElementId = "mySkippedDays";
const SkipDays = () => {
    var _a, _b;
    const { allSkipDays, configuration, error, hasSkipDays, isLoading, isMutating, loadingText, skipDaysByMonth, skippedDays, triggerUpdateSkipDay, } = useSkipDaysQuery();
    const Mobile = (props) => _jsx(Responsive, Object.assign({}, props, { maxWidth: 768 }));
    const Desktop = (props) => _jsx(Responsive, Object.assign({}, props, { minWidth: 769 }));
    const mySkippedDaysElementWidth = (_b = (_a = document.getElementById(mySkippedDaysElementId)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 210;
    // ===== CONDITIONAL RENDERING =====
    const showLoader = isLoading || isMutating;
    const showError = !showLoader && !!error;
    const showNoSkipDays = !showLoader && !error && !hasSkipDays && allSkipDays !== undefined; // Ensure data is resolved
    const showSkipDays = !showLoader && !error && hasSkipDays && allSkipDays !== undefined;
    // TODO-MUI: This needs to be refactored so that the Desktop/Mobile wrapper is conditional and we aren't rewriting the same code twice.
    return (_jsxs(AccountPageWrapper, Object.assign({ id: "skip-days" }, { children: [_jsx(AccountPageTitle, { title: "Skip Days", subtitle: configuration === null || configuration === void 0 ? void 0 : configuration.SkipDaysSubHeadingText }), showLoader && _jsx(Loading, { text: loadingText }), showError && _jsx(Typography, Object.assign({ textAlign: "center" }, { children: error })), showNoSkipDays && _jsx(Typography, Object.assign({ textAlign: "center" }, { children: "No Skip Days to display" })), showSkipDays && (_jsxs(_Fragment, { children: [_jsxs(Desktop, { children: [_jsx(Stack, Object.assign({ id: "desktop-content" }, { children: _jsxs(Stack, Object.assign({ justifyContent: "center" }, { children: [_jsx(Stack, Object.assign({ justifyContent: "center", flexDirection: "row", flexWrap: "wrap", gap: 4, 
                                            // Width is adjusted to prevent mySkippedDays element from overlapping a calendar
                                            width: `calc(100% - ${mySkippedDaysElementWidth * 1.8}px)`, alignSelf: "center" }, { children: skipDaysByMonth &&
                                                skipDaysByMonth.map((month) => {
                                                    if (month.days.length > 0) {
                                                        return (_jsx(SkipDayCalendar, { allSkipDays: allSkipDays, handleUpdateSkipDay: triggerUpdateSkipDay, modalText: configuration === null || configuration === void 0 ? void 0 : configuration.SkipDaysWarningModalText, modalTitle: configuration === null || configuration === void 0 ? void 0 : configuration.SkipDaysWarningModalTitle, month: month, shouldDisableDate: shouldDisableDate(allSkipDays) }, month.month));
                                                    }
                                                }) })), _jsx(Legend, {})] })) })), _jsx(MySkippedDaysDesktop, Object.assign({ id: mySkippedDaysElementId }, { children: _jsx(MySkippedDays, Object.assign({}, {
                                    skippedDays,
                                    allSkipDays,
                                    handleUpdate: triggerUpdateSkipDay,
                                })) }))] }), _jsxs(Mobile, { children: [_jsx(Stack, Object.assign({ justifyContent: "space-evenly", alignItems: "center" }, { children: skipDaysByMonth && skipDaysByMonth.length > 0 && (_jsx(SkipDayCalendar, { allSkipDays: allSkipDays, handleUpdateSkipDay: triggerUpdateSkipDay, modalText: configuration === null || configuration === void 0 ? void 0 : configuration.SkipDaysWarningModalText, modalTitle: configuration === null || configuration === void 0 ? void 0 : configuration.SkipDaysWarningModalTitle, shouldDisableDate: shouldDisableDate(allSkipDays), skipDaysByMonth: skipDaysByMonth })) })), _jsx(Legend, {}), _jsx(MySkippedDaysMobile, Object.assign({ id: mySkippedDaysElementId }, { children: _jsx(MySkippedDays, Object.assign({}, {
                                    skippedDays,
                                    allSkipDays,
                                    handleUpdate: triggerUpdateSkipDay,
                                })) }))] })] }))] })));
};
export default SkipDays;
//TODO-MUI: UPDATE ALL STYLES TO LEVERAGE THE MUI V5 THEME AND STYLING OPTIONS.
const MySkippedDaysDesktop = styled.div `
  border-radius: 5px;
  padding: 15px;
  position: fixed !important;
  width: 210px;
  height: 150px;
  top: 300px;
  right: 0;
  background: #fff;
  z-index: 1100;
  opacity: 1;
  overflow: overlay;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
`;
//TODO-MUI: UPDATE ALL STYLES TO LEVERAGE THE MUI V5 THEME AND STYLING OPTIONS.
const MySkippedDaysMobile = styled.div `
  border-radius: 5px;
  padding: 15px;
  height: 150px;
  background: #fff;
  opacity: 1;
  overflow: overlay;
  margin-top: 20px;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
`;
//TODO-MUI: UPDATE ALL STYLES TO LEVERAGE THE MUI V5 THEME AND STYLING OPTIONS.
export const SkipDay = withStyles({
    root: {
        backgroundColor: "#cfcfc4",
        color: "black",
    },
})(PickersDay);
//TODO-MUI: UPDATE ALL STYLES TO LEVERAGE THE MUI V5 THEME AND STYLING OPTIONS.
export const DisabledDay = withStyles({
    root: {
        opacity: ".5",
    },
})(PickersDay);
